import HoneyTrustPilot from 'components/views/honey_trust_pilot';

const component = {
  components: {
    'honey-trust-pilot': HoneyTrustPilot,
  },
};

export default component;
